import { Guid, Nillable } from '@web/utils';
import { PaymentMethodCode } from '@web/shared/module/shop';
import { Multimedia } from '@web/shared/module/multimedia';

export class AdminPaymentMethodDetails {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeViewed: boolean;
      id: Guid;
      isActive: boolean;
      code: PaymentMethodCode;
      name: string;
      description: string;
      createdAt: Date;
      previewFile?: Nillable<Multimedia>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get code(): PaymentMethodCode {
    return this.data.code;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get description(): string {
    return this.data.description;
  }

  public get isActive(): boolean {
    return this.data.isActive;
  }

  public get previewFile(): Nillable<Multimedia> {
    return this.data.previewFile;
  }
}
